import type {
  ToggleMessageReactionMutation,
  ToggleMessageReactionMutationVariables,
} from '#src/graphql/generated';
import type { TypedDocumentNode } from '@apollo/client';

import { gql } from '@apollo/client';

import { MESSAGE_FIELDS } from '#src/graphql/fragments/message-fields';

export const TOGGLE_MESSAGE_REACTION: TypedDocumentNode<
  ToggleMessageReactionMutation,
  ToggleMessageReactionMutationVariables
> = gql`
  ${MESSAGE_FIELDS}
  mutation ToggleMessageReaction($input: ToggleMessageReactionInput!) {
    toggleMessageReaction(input: $input) {
      ...MessageFields
    }
  }
`;
